// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/UnileverShilling.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/UnileverDesire-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/UnileverDesire-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/UnileverDesire-RegularItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/UnileverDesire-Light.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Unilever Shilling";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Semi Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Regular Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Unilever Desire Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
  font-weight: 300;
  font-style: normal;
}
.EstimatedBestPrice_mainDiv__nE8DB {
  margin-left: 180px;
  margin-right: 180px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .EstimatedBestPrice_mainDiv__nE8DB {
    margin-left: 16px;
    margin-right: 0px;
  }
}

.EstimatedBestPrice_headerContainer__X1s4B {
  display: flex;
  justify-content: space-between;
}
.EstimatedBestPrice_headerContainer__X1s4B .EstimatedBestPrice_title__qEykR {
  margin-top: 57px;
  color: #262525;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .EstimatedBestPrice_headerContainer__X1s4B .EstimatedBestPrice_title__qEykR {
    margin-top: 20px;
    font-size: 18px;
    line-height: 16px; /* 88.889% */
  }
}
.EstimatedBestPrice_headerContainer__X1s4B .EstimatedBestPrice_estimatedPriceContainer__R2zac {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 23px;
  margin-top: 55px;
}
.EstimatedBestPrice_headerContainer__X1s4B .EstimatedBestPrice_estimatedPriceContainer__R2zac .EstimatedBestPrice_addBestPrice__sF5Zt {
  color: #275CE6;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
  margin-bottom: 0px;
  cursor: pointer;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .EstimatedBestPrice_headerContainer__X1s4B .EstimatedBestPrice_estimatedPriceContainer__R2zac {
    margin-top: 20px;
    margin-right: 16px;
  }
}

.EstimatedBestPrice_headingOne__aNyTa {
  margin-top: 10px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #333c43;
}

.EstimatedBestPrice_headingDiv__fLoZ5 {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #333c43;
  border: 1px solid #cccfd0;
  border-radius: 8px;
  font-weight: bold;
  width: 73vw;
  height: auto;
}
.EstimatedBestPrice_headingDiv__fLoZ5 img {
  padding-left: 10px;
  padding-top: 10px;
  margin-bottom: 5px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .EstimatedBestPrice_headingDiv__fLoZ5 {
    width: 95vw;
  }
}

.EstimatedBestPrice_headingTwo__uniQR {
  width: 95%;
  float: left;
  padding-left: 10px;
  padding-top: 10px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .EstimatedBestPrice_headingTwo__uniQR {
    width: 92%;
  }
}

.EstimatedBestPrice_activeList__tVkNq {
  padding-bottom: 30px;
}

.EstimatedBestPrice_errorWrapper__icZFa {
  padding: 1.25rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_mixin.scss","webpack://./src/components/EstimatedBestPrice/EstimatedBestPrice.module.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAIA;EACE,gCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;ACHF;ADMA;EACE,sCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACJF;ADQA;EACE,wCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACNF;ADUA;EACE,mCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACRF;ADWA;EACE,6CAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACTF;ADYA;EACE,oCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACVF;AAhCA;EACE,kBAAA;EACA,mBAAA;AAkCF;ADwBE;EC5DF;IAII,iBAAA;IACA,iBAAA;EAoCF;AACF;;AAjCA;EACE,aAAA;EACA,8BAAA;AAoCF;AAlCE;EACE,gBAAA;EACA,cAAA;EACA,eC0BkB;EDzBlB,kBAAA;EACA,gBCgCmB;ED/BnB,mBAAA;AAoCJ;ADKE;EC/CA;IASI,gBAAA;IACA,eAAA;IACA,iBAAA,EAAA,YAAA;EAqCJ;AACF;AAlCE;EACE,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;AAoCJ;AAlCI;EACE,cCpCO;EDqCP,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,kBAAA;EACA,eAAA;AAoCN;ADnBE;EChCA;IAmBI,gBAAA;IACA,kBAAA;EAoCJ;AACF;;AAhCA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,WAAA;EACA,YAAA;AAkCF;AAjCE;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;AAmCJ;ADpDE;ECEF;IAkBI,WAAA;EAoCF;AACF;;AAjCA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAoCF;ADhEE;ECwBF;IAMI,UAAA;EAsCF;AACF;;AAnCA;EACE,oBAAA;AAsCF;;AAnCA;EACE,gBAAA;AAsCF","sourcesContent":["@import \"./variables\";\n\n// Font family\n\n@font-face {\n  font-family: \"Unilever Shilling\";\n  src: url(\"../fonts/UnileverShilling.ttf\")format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Unilever Desire Regular\";\n  src: url(\"../fonts/UnileverDesire-Regular.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n@font-face {\n  font-family: \"Unilever Desire Semi Bold\";\n  src: url(\"../fonts/UnileverDesire-Bold.woff\") format(\"woff\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n\n@font-face {\n  font-family: \"Unilever Desire Bold\";\n  src: url(\"../fonts/UnileverDesire-Bold.woff\") format(\"woff\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Unilever Desire Regular Italic\";\n  src: url(\"../fonts/UnileverDesire-RegularItalic.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Unilever Desire Light\";\n  src: url(\"../fonts/UnileverDesire-Light.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: normal;\n}\n\n\n\n\n\n// Font families and font-weights\n\n@mixin volteMedium {\n  font-family: \"Unilever Shilling\", sans-serif;\n}\n\n@mixin volteSemibold {\n  font-family: \"Unilever Shilling\", sans-serif;\n}\n\n@mixin sm {\n  @media only screen and (min-width: 320px) and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media only screen and (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm-min {\n  @media only screen and (min-width: 992px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media only screen and (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl-min {\n  @media only screen and (min-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media only screen and (min-width: 1280px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media only screen and (min-width: 1440px) {\n    @content;\n  }\n}\n\n@mixin sm-tab {\n  @media only screen and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin ipad {\n  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n    @content;\n  }\n}\n\n","@import \"../../assets/styles/variables\";\n@import \"../../assets//styles/mixin\";\n\n.mainDiv {\n  margin-left: 180px;\n  margin-right: 180px;\n  @include sm {\n    margin-left: 16px;\n    margin-right: 0px;\n  }\n}\n\n.headerContainer {\n  display: flex;\n  justify-content: space-between;\n\n  .title {\n    margin-top: 57px;\n    color: #262525;\n    font-size: $font-size-lg-medium;\n    font-style: normal;\n    font-weight: $font-weight-semibold;\n    line-height: normal;\n\n    @include sm {\n      margin-top: 20px;\n      font-size: 18px;\n      line-height: 16px; /* 88.889% */\n    }\n  }\n\n  .estimatedPriceContainer {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 23px;\n    margin-top: 55px;\n\n    .addBestPrice {\n      color: $primaryBlue;\n      text-align: right;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 120%; /* 16.8px */\n      margin-bottom: 0px;\n      cursor: pointer;\n    }\n\n    @include sm {\n      margin-top: 20px;\n      margin-right: 16px;\n    }\n  }\n}\n\n.headingOne {\n  margin-top: 10px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  color: #333c43;\n}\n\n.headingDiv {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  color: #333c43;\n  border: 1px solid #cccfd0;\n  border-radius: 8px;\n  // padding: 10px;\n  font-weight: bold;\n  width: 73vw;\n  height: auto;\n  img {\n    padding-left: 10px;\n    padding-top: 10px;\n    margin-bottom: 5px;\n  }\n  @include sm {\n    width: 95vw;\n  }\n}\n\n.headingTwo {\n  width: 95%;\n  float: left;\n  padding-left: 10px;\n  padding-top: 10px;\n  @include sm {\n    width: 92%;\n  }\n}\n\n.activeList {\n  padding-bottom: 30px;\n}\n\n.errorWrapper {\n  padding: 1.25rem;\n}","// Color codes here.\n$headerBlue:#275CE6;\n$headerBorder:#5588F7;\n$primaryBlue:#275CE6;\n$secondryBlue:#5588F7;\n$white:#FFFFFF;\n$tertiaryGrey:#676E72;\n$errorRed: #D52F3D;\n$progressRed:#E43263;\n$errorRed: #D52F3D;\n$progressGreen:#59B876;\n$progressCircleGrey:#9496A0;\n$black:#000000;\n$timedetailsGrey:#F3F7FD;\n$buttonbgBlue:#5588F7;\n$inputBorder:#CCCFD0;\n$buttonDisableBg:#E5E6E7;\n$buttonDisableText:#999EA1;\n$errorMessageRed:#FF5C83;\n$darkGreyText:#333C43;\n$tableHeader:#F6FCFF;\n$LandingPageBlue:#1E49B9;\n$secondary_lightish:#E1ECF5;\n$opTabViewDisabled:#F2F3F3;\n$otpGreyText:#B3B6C5;\n$otpErrorRed:#D52F3D;\n$oddTableRow: #f8f9fc;\n$agTableRow: #f3f3f3;\n$scrollbar: #888;\n$scrollbarHover: #555;\n$scrollbarTrack: #f1f1f1;\n$dropdownListColor: #f0f0f0;\n$dropdownShadow: #6123E70F;\n$disableButton : #cccccc;\n$progressContainer: #e0e0e0;\n$toggleSwitchOff: #00000066;\n$toggleSwitchOn: #03A742;\n// Font Sizes\n$font-size-xs-small: 10px;\n$font-size-sm-small: 12px;\n$font-size-sm-base: 14px;\n$font-size-md-medium: 16px;\n$font-size-md-large: 18px;\n$font-size-md-xtraLarge: 20px;\n$font-size-md-xLarge: 22px;\n$font-size-lg-medium: 24px;\n$font-size-xl-large: 32px;\n$font-size-xl-xtraLarge: 40px;\n$font-size-xl-medium: 28px;\n\n// Font weights\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n// Font Styles\n$font-style: 'Unilever Shilling';\n$font-family-desire-light: 'Unilever Desire Light', sans-serif;\n\n// Line Height\n$line-height-medium: 16px;\n\n// Spacing\n$spacing-zero: 0px;\n$spacing-xs: 10px;\n$spacing-sm: 12px;\n$spacing-sm-m: 14px;\n$spacing-md: 16px;\n$spacing-md-m: 18px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainDiv": `EstimatedBestPrice_mainDiv__nE8DB`,
	"headerContainer": `EstimatedBestPrice_headerContainer__X1s4B`,
	"title": `EstimatedBestPrice_title__qEykR`,
	"estimatedPriceContainer": `EstimatedBestPrice_estimatedPriceContainer__R2zac`,
	"addBestPrice": `EstimatedBestPrice_addBestPrice__sF5Zt`,
	"headingOne": `EstimatedBestPrice_headingOne__aNyTa`,
	"headingDiv": `EstimatedBestPrice_headingDiv__fLoZ5`,
	"headingTwo": `EstimatedBestPrice_headingTwo__uniQR`,
	"activeList": `EstimatedBestPrice_activeList__tVkNq`,
	"errorWrapper": `EstimatedBestPrice_errorWrapper__icZFa`
};
export default ___CSS_LOADER_EXPORT___;
